// import React from 'react';
import React from 'react';
import { getSessionData } from '../sessionStorage/sessionStorage';


const SupportEmail = () => {

  const url = getSessionData('url') || '';
  let course = '';

  const isBrowser = typeof window !== 'undefined';
  if (isBrowser) {
    const params = new URL(document.location).searchParams;
    course = params.get('title');
  }

  const href = `mailto:eltsupport@oup.com?subject=VST%201.5%20Help&body=Your%20name%20and%20email%20address%3A%0A%0AThe%20title%20of%20the%20book%20you%20are%20using%3A%20${course}, ${url}%0A%0AThe%20problem%20you%20are%20having%3A%0A%0AYour%20access%20code%3A%0A%0AYour%20operating%20system%20and%20browser%20version%3A%0A%0A`;

  return (
        <a href={href} target="_blank">eltsupport@oup.com</a>
  );
};

export default SupportEmail;


// WEBPACK FOOTER //
// ./src/components/SupportEmail/SupportEmail.js